import {
  ArrayField,
  Datagrid,
  FunctionField,
  NumberField,
  ReferenceField,
  TextField,
  useRecordContext,
} from "react-admin";
import { Box, Chip } from "@mui/material";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { doctoralRequests } from "api/doctoralApi";
import ScheduleExamDialog from "./ScheduleExamDialog";
import ExamCommitteeDialog from "./ExamCommitteeDialog";
import DoctoralDateField from "../../Partials/DoctoralDateField";

const committeeChip = exam => {
  if (!exam.hasCommittee) return <Chip size="small" label="—" />;
  return (
    <Chip
      size="small"
      color={exam.isCommitteeApproved ? "success" : "default"}
      label={exam.isCommitteeApproved ? "Утвърдена" : "Очаква утвърждаване"}
    />
  );
};

const ExamsSection = () => {
  const campaign = useRecordContext();
  if (!campaign) return null;

  return (
    <ArrayField source="exams">
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        sx={settings.style.secondaryDatagrid}
        empty={<em>Няма дисциплини</em>}
      >
        <ReferenceField
          label="Дисциплина"
          source="doctoralDisciplineId"
          reference={doctoralRequests.getDoctoralDisciplinesSelect()}
          link={false}
          sortable={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <NumberField source="admittedCandidatesCount" label="Допуснати" sortable={false} />
        <DoctoralDateField source="examDate" label="Дата на изпита" showTime sortable={false} emptyText="—" />
        <ReferenceField
          label="Зала"
          source="examRoomId"
          reference={administrationRequests.getRoomsSelect()}
          link={false}
          sortable={false}
          emptyText="—"
        >
          <FunctionField render={r => (r ? `${r.roomName} - ${r.buildingName}` : "—")} />
        </ReferenceField>
        <FunctionField label="Комисия" render={committeeChip} />
        <FunctionField
          label=""
          render={exam =>
            exam.admittedCandidatesCount > 0 ? (
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                <SecuredComponent permission={permissions.canUpdateDoctoralExamCommittees}>
                  <ExamCommitteeDialog
                    campaignId={campaign.id}
                    disciplineId={exam.doctoralDisciplineId}
                    structuralUnitId={campaign.structuralUnitId}
                    exam={exam}
                  />
                </SecuredComponent>
                {exam.isCommitteeApproved ? (
                  <SecuredComponent permission={permissions.canUpdateDoctoralCampaigns}>
                    <ScheduleExamDialog
                      campaignId={campaign.id}
                      disciplineId={exam.doctoralDisciplineId}
                      exam={exam}
                    />
                  </SecuredComponent>
                ) : (
                  <span style={{ fontSize: 12, color: "#888" }}>
                    Първо утвърдете изпитна комисия
                  </span>
                )}
              </Box>
            ) : (
              <span>Няма допуснати кандидати</span>
            )
          }
        />
      </Datagrid>
    </ArrayField>
  );
};

export default ExamsSection;
